import { render, staticRenderFns } from "./TimetableText.vue?vue&type=template&id=18238ec0"
import script from "./TimetableText.vue?vue&type=script&lang=js"
export * from "./TimetableText.vue?vue&type=script&lang=js"
import style0 from "./TimetableText.vue?vue&type=style&index=0&id=18238ec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports